import React, { Component } from "react";
import StudentAppBar from "../StudentAppBar";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import PropTypes from "prop-types";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { Link } from "react-router";
import AdmissionApi from "../../Services/AdmissionApi";
import Paging from "../Paging";
import StudentSideBar from "../StudentSideBar";
import "./style.css";

class AdmissionAlerts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: window.innerWidth < 980 ? false : true,
      alerts: [],
      showLoading: true,
      categories: [],
      page: 1,
      pageSize: 6,
      totalPages: 1,
      institutionName: '',
      selectedCategory: '',
      lastApplyFrom: '',
      lastApplyTo: '',
      passingYear: ''
    };

    this.handlePageChange = this.handlePageChange.bind(this)
    this.admissionsService = new AdmissionApi()
  }

  static get contextTypes() {
    return {
      router: PropTypes.object.isRequired,
    };
  }

  componentDidMount() {
    const isLogin = localStorage.getItem("isLogin")

    if (isLogin == 1) {
      let category = localStorage.getItem("categories")
      
      this.setState({ categories: category });
      this.getStudentBatch()
    } else {
      this.context.router.push("/signIn");
    }
  }

  cbUserInfo = (newResponse) => {
    if (!newResponse.data.success) return

    const student = newResponse.data._embedded.students[0]
    if (student) {
      this.setState({
        passingYear: student.batch,
      })
      setTimeout(() => this.getAll(), 300)
    }

  }

  getStudentBatch = () => {
    const userId = localStorage.getItem("userId")

    this.admissionsService.GetData(
      this.cbUserInfo,
      "v1/students?user_id=" + userId
    )
  }

  updateState = (response) => {
    this.setState({
      showLoading: false,
      alerts: response.data._embedded.admissionalerts,
      page: response.data.page,
      totalPages: response.data.pageCount,
    });
  };

  getCourse = (data) => {
    let _data = JSON.parse(data);
    return Object.values(_data);
  }

  getAll(page = 1) {
    const _userCategories = JSON.parse(localStorage.getItem('categories'))
    const userCategories = _userCategories.reduce((res, item) => [...res, item.value], [])

    let filters = ''
    const {
      institutionName,
      selectedCategory,
      lastApplyFrom,
      lastApplyTo,
      pageSize,
      passingYear
    } = this.state

    if (institutionName) filters += `&institution_name=${institutionName}`
    if (lastApplyFrom) filters += `&last_date_to_apply_from=${lastApplyFrom}`
    if (lastApplyTo) filters += `&last_date_to_apply_to=${lastApplyTo}`
    if (passingYear) filters += `&year_of_passing=${passingYear}`
    filters += `&course_category_id=${selectedCategory ? selectedCategory : userCategories}`

    this.admissionsService.GetData(
      this.updateState,
      `v1/alerts/admissionalerts?page=${page}&pageSize=${pageSize}&column=created_at&order=desc&userId=${localStorage.getItem('userId')}&userRole=student${filters}`
    );
  }

  handleFilterInputChange = (event) => {
    const { id, value } = event.target
    this.setState({
      [id]: value
    })
  }

  filterList = (e) => {
    e.preventDefault()
    this.getAll()
  }

  clearFilter = () => {
    this.setState({
      institutionName: '',
      selectedCategory: '',
      lastApplyFrom: '',
      lastApplyTo: '',
    }, this.getAll)
  }

  handlePageChange = (page) => {
    this.getAll(page)
  }

  toggleSidebar = () => {
    this.setState(state => ({ isOpen: !state.isOpen }))
  }

  handleRequestChange = (isOpen) => {
    this.setState({ isOpen })
  }

  cbFavSuccess = (res) => {
    if (res.data.success === true) {
      this.getAll(this.state.page)
    }
  }

  onApplyNow = (data) => {
    let obj = {
      alertType: 1, // 1 for admission alerts and 2 for scholarship
      alertId: data.id,
      userRole: 'student',
      userId: localStorage.getItem('userId')
    }

    this.admissionsService.createNew(
      this.cbFavSuccess,
      obj,
      `v1/alerts/favourites`
    )
  }

  render() {

    const {
      page,
      alerts,
      totalPages,
      institutionName,
      selectedCategory,
      lastApplyFrom,
      lastApplyTo,
      isOpen,
    } = this.state

    const _userCategories = JSON.parse(localStorage.getItem('categories'))
    const _userCategoriesWithTagColor = _userCategories.map((item, i) => ({ ...item, tagColor: `hsl(${300 + i * 50}deg 36% 84%)` }))
    const userCategories = _userCategories.reduce((res, item) => [...res, item.label], [])

    return (
      <MuiThemeProvider>
        <div className="dash-container">
          <StudentSideBar isOpen={isOpen} handleRequestChange={this.handleRequestChange} />

          <div className="dash-content">
            <StudentAppBar title="Admission Alerts" toggleSidebar={this.toggleSidebar} router={this.props.router} />
            <div className="container">
              <section className="dash-alerts">
                <form>
                  <div className="alert-filter">
                    <div className="form-group mr-2 mb-0">
                      <label>Institution Name</label>
                      <input
                        type="text"
                        id="institutionName"
                        className="form-control alert-filter__input"
                        placeholder="Institution Name"
                        value={institutionName}
                        onChange={this.handleFilterInputChange}
                      />
                    </div>
                    <div className="form-group mr-2 mb-0">
                      <label>Category</label>
                      <select
                        className="form-control alert-filter__input"
                        id="selectedCategory"
                        value={selectedCategory}
                        onChange={this.handleFilterInputChange}
                      >
                        <option value="">Choose...</option>
                        {_userCategories.map(item => (
                          <option key={item.value} value={item.value}>{item.label}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group mr-2 mb-0">
                      <label>Last Apply From</label>
                      <input
                        type="date"
                        id="lastApplyFrom"
                        value={lastApplyFrom}
                        onChange={this.handleFilterInputChange}
                        className="form-control alert-filter__input"
                      />
                    </div>
                    <div className="form-group mr-2 mb-0">
                      <label>Last Apply To</label>
                      <input
                        type="date"
                        id="lastApplyTo"
                        value={lastApplyTo}
                        onChange={this.handleFilterInputChange}
                        className="form-control alert-filter__input"
                      />
                    </div>
                    <button
                      className="btn btn--primary align-self-end"
                      onClick={this.filterList}
                      type="submit"
                    >
                      Submit
                    </button>
                    <button
                      className="btn btn--default align-self-end ml-2"
                      onClick={this.clearFilter}
                      type="button"
                    >
                      Clear
                    </button>
                  </div>
                </form>
                <table className="table table-responsive alert-table">
                  <thead>
                    <tr>
                      <th scope="col">Institution</th>
                      <th scope="col">Last date to apply</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {alerts.map(item => (
                      <tr key={item.id}>
                        <td>
                          <div>
                            <p style={{ fontWeight: 'bold' }} className="m-0">{item.subject_line}</p>
                            <p style={{ color: '#2c2c2c' }} className="m-0">{item.institution_name}</p>
                            {this.getCourse(item.course_category_id).map((item, i) => (
                              <span
                                key={i}
                                className="badge mr-2 mb-1"
                                style={{ backgroundColor: _userCategoriesWithTagColor.reduce((r, o) => o.label === item ? o.tagColor : r, ''), display: !userCategories.includes(item) ? 'none' : null }}
                              >
                                {item}
                              </span>
                            ))}
                          </div>
                        </td>
                        <td>{item.last_date_online}</td>
                        <td className="d-flex">
                          <Link title="Click to view details" to={{ pathname: "/alertDetail", state: { data: item } }} className="btn btn-link alert-table__link">
                            <i className="icon-eye fw-bold" />
                          </Link>
                          <button title={!item.isFavourite ? 'Save this alert to your favourites' : 'Remove this alert to your favourites'} className="btn btn-link alert-table__link" onClick={() => this.onApplyNow(item)}>
                            {!item.isFavourite ? (
                              <i className="icon-heart fw-bold" style={{ color: item.isFavourite ? 'red' : null }} />
                            ) :
                            (
                              <svg xmlns="http://www.w3.org/2000/svg" style={{ color: 'red', width: 20 }} viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd" />
                              </svg>
                            )}
                          </button>
                        </td>
                      </tr>
                    ))}
                    {!alerts.length && (
                      <tr>
                        <td colSpan={2}>No Alerts Available!</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <Paging page={page} totalPages={totalPages} onChange={this.handlePageChange} />
              </section>
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    )
  }
}

export default AdmissionAlerts;



/** WEBPACK FOOTER **
 ** ./src/components/AdmissionAlerts/index.js
 **/